import React, { useState, useEffect } from "react";
import { Table, Row, Col, Card, CardBody, CardTitle, CardSubtitle, Input, Label, Button, Form, Alert } from "reactstrap";
import { post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import UploadImage from "common/uploadImage";
import ShipmentTypesSelect from "common/shipmentTypesSelect";
import { ADD_SERVICE } from "helpers/api_endpoints";


//meta title
document.title = "Add Service";

const AddService = () => {

    const [status, setStatus] = useState(0);
    const [name, setName] = useState('');
    const [type, setType] = useState(1);
    const [symbol, setSymbol] = useState('');
    const [price, setPrice] = useState(0);
    const [description, setDescription] = useState('');
    const [errorMsg, seterrorMsg] = useState('');
    const [image, setImage] = useState('');
    const [shipmentTypeIds, setShipmentTypeIds] = useState([]);
    const navigate = useNavigate();

    const handleSubmit = () => {
        const imagePath = document.getElementById('imagePath').value;
        post(ADD_SERVICE, { type, name, status, symbol, description, price, image: imagePath, shipmentTypeIds })
            .then(response => {
                if (response.code == 201) {
                    navigate('/services', { state: { successMsg: 'Added SuccessFully' } });
                }
            })
            .catch(error => {
                seterrorMsg('Creation Failed');
            })
    }

    const handleToggleCheckBoxStatus = () => {
        if (status) {
            setStatus(0);
        }
        else {
            setStatus(1)
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Services" breadcrumbItem="Add Service" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        <Row>
                                            {errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}

                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Type</Trans></Label>
                                                <Input
                                                    name="type"
                                                    value={type}
                                                    className="form-control"
                                                    placeholder="Enter  Type"
                                                    type="number"
                                                    onChange={(e) => setType(e.target.value)}
                                                    required ></Input>
                                            </div>


                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Name</Trans></Label>
                                                <Input
                                                    name="name"
                                                    value={name}
                                                    className="form-control"
                                                    placeholder="Enter Name"
                                                    type="text"
                                                    onChange={(e) => setName(e.target.value)}
                                                    required ></Input>
                                            </div>

                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Price</Trans></Label>
                                                <Input
                                                    name="price"
                                                    value={price}
                                                    className="form-control"
                                                    placeholder="Enter Price"
                                                    type="text"
                                                    onChange={(e) => setPrice(e.target.value)}
                                                    required ></Input>
                                            </div>

                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Symbol</Trans></Label>
                                                <Input
                                                    name="symbol"
                                                    value={symbol}
                                                    className="form-control"
                                                    placeholder="Enter Symbol"
                                                    type="text"
                                                    onChange={(e) => setSymbol(e.target.value)}
                                                ></Input>
                                            </div>

                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Description</Trans></Label>
                                                <textarea
                                                    name="description"
                                                    value={description}
                                                    className="form-control"
                                                    placeholder="Enter Description"
                                                    type="text"
                                                    onChange={(e) => setDescription(e.target.value)}
                                                    required ></textarea>
                                            </div>

                                            <ShipmentTypesSelect
                                                value={shipmentTypeIds}
                                                onChange={setShipmentTypeIds}
                                            />

                                            <UploadImage state={{ InputLabel: 'Image', filePath: image, type: 'services', InputWidth: '4' }}></UploadImage>

                                            <div className="form-group col-md-2 mt-2">
                                                <Label className="form-label"><Trans>Status</Trans></Label>
                                                <div className="form-check form-check-end">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        value={1}
                                                        id="defaultCheck2"
                                                        checked={status}
                                                        onClick={handleToggleCheckBoxStatus}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="defaultCheck2"
                                                    >
                                                        <Trans>Active</Trans>
                                                    </label>
                                                </div>
                                            </div>

                                        </Row>
                                        <div className="mt-4">
                                            <Button type="submit" color="danger">
                                                <Trans>Submit</Trans>
                                            </Button>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default AddService
